import React from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

const Header = ({
  initialRole,
  selectedRole,
  handleRoleChange,
  practiceData,
}) => {
  const roles =
    practiceData.data?.map((item) => ({
      slug: item.slug,
      name: item.type || item.slug,
      description: item.description,
    })) || [];

  const selectedRoleName =
    roles.find((role) => role.slug === selectedRole)?.name || selectedRole;

  const description =
    roles.find((role) => role.name === selectedRole)?.description || "";

  const filteredRoles = roles.filter((role) => role.slug !== selectedRole);

  return (
    <header
      className={`flex flex-col items-center px-4 ${
        selectedRole === "Flow Into Apex"
          ? "my-6 sm:my-12 mb-32 sm:mb-64"
          : "my-4 sm:my-8"
      }`}
    >
      <h1 className="text-2xl sm:text-4xl font-bold text-white mb-4">
        <div className="dropdown dropdown-hover inline-block relative">
          <label
            tabIndex={0}
            className="cursor-pointer text-purple-300 flex items-center hover:text-purple-400 transition-colors duration-300"
          >
            {initialRole === "{Your Role}" ? (
              <span className="text-purple-400 animate-[pulse_3s_infinite]">
                {/* {initialRole} */}
              </span>
            ) : (
              selectedRoleName
            )}

            {initialRole !== "{Your Role}" && (
              <ChevronDown className="ml-2 h-5 w-5 sm:h-6 sm:w-6" />
            )}
          </label>

          <ul
            tabIndex={0}
            className="dropdown-content menu p-2 shadow bg-gray-800 rounded-lg w-48 sm:w-56 text-sm sm:text-base"
          >
            {filteredRoles.map((role) => (
              <li key={role.slug}>
                <button
                  onClick={() => handleRoleChange(role.slug)}
                  className="w-full text-left py-2 px-4 hover:bg-gray-700 rounded text-white"
                >
                  {role.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </h1>

      {selectedRole === "Flow Into Apex" && (
        <div className="text-center mb-3 px-4">
          <p className="text-md text-zinc-300 mb-6 sm:mb-8"></p>
          <div className="bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 p-1 rounded-lg inline-block">
            <div className="bg-zinc-900 px-4 sm:px-6 py-2 sm:py-3 rounded-lg">
              <Link
                to={`https://www.linkedin.com/in/kimberlylsmall/`}
                className="hover:text-blue-300 text-lg sm:text-xl font-bold bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                By Kimberly Small
              </Link>
              <p className="text-zinc-400 text-xs sm:text-sm">
                Salesforce Developer | Snap2Case Founder | 8x Certified
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="pt-4 px-4 w-full sm:w-10/12 md:w-8/12 lg:w-7/12 mb-16">
        <ReactMarkdown
          className="text-center text-sm sm:text-base text-gray-200"
          children={description}
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw]}
        />
      </div>
    </header>
  );
};

export default Header;
